// @flow
import { _get } from "./methods";

export default {
  dashboard: (params: any) => _get("/admin/later_matching/dashboard", params)
};
